module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/json-loader!./.cache/json/layouts-level.json
// module id = 1069
// module chunks = 218829201806838